import React, { useEffect, useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import AdminReply from "../../atoms/ProjectCommunication/AdminReply";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { getBuyerTransactionCommunication } from "../../../utils/API/getBuyerTransactionCommunication";
import { getSellerTransactionCommunication } from "../../../utils/API/getSellerTransactionCommunication";

const ActionRequired = ({
  open,
  onCancel,
  userType,
  transactionId,
  bidType,
}) => {
  const [communications, setCommunications] = useState([]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (transactionId !== 0) {
      fetchCommunication();
    }
  }, [transactionId, open]);

  const fetchCommunication = async () => {
    try {
      if (
        userType === "buyer" ||
        (userType === "trader" && bidType === "Buy")
      ) {
        const response = await getBuyerTransactionCommunication(
          transactionId,
          dispatch
        );
        if (response.success && Array.isArray(response.data)) {
          setCommunications(response.data);
        } else {
          setCommunications([]);
        }
        // console.log("Response", response.data);
      }
      if (
        userType === "seller" ||
        (userType === "trader" && bidType === "Sell")
      ) {
        const response = await getSellerTransactionCommunication(
          transactionId,
          dispatch
        );
        if (response.success && Array.isArray(response.data)) {
          setCommunications(response.data);
        } else {
          setCommunications([]);
        }
      }
    } catch (error) {
      toast.error("Failed to fetch communications");
    }
  };

  return (
    <DiaglogBox width={800} open={open} onCancel={onCancel}>
      <div className="pb-5 my-10 overflow-hidden overflow-y-scroll no-scrollbar">
        <h4 className="pt-8 w-full text-black text-[1.5625rem] font-bold text-center">
          Action Required
        </h4>
        <hr />
        <div className="px-10">
          <h3 className="text-[1.5rem] font-medium">Communication</h3>
          <div className="pt-6">
            {communications.length > 0 ? (
              communications.map((message, index) => (
                <div key={`${index}_reply`}>
                  <AdminReply
                    message={message}
                    actionRequired={true}
                    userType={userType}
                    transactionId={transactionId}
                    setChat={setCommunications}
                  />
                </div>
              ))
            ) : (
              <p>No communications available.</p>
            )}
          </div>
        </div>
      </div>
    </DiaglogBox>
  );
};

export default ActionRequired;
